exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notificationsContainer {\n    position: fixed;\n    bottom: 10px;\n    right: 10px;\n    display: flex;\n    flex-direction: column-reverse;\n    justify-content: flex-end;\n    align-items: flex-end;\n    grid-gap: 2px;\n    gap: 2px;\n    z-index: 1500;\n}\n\n.notificationsContainer .notificationsContainer_text {\n    font-size: 16px;\n}\n.notificationsContainer .notificationsContainer_action button {\n    width: 36px;\n    height: 36px;\n}\n\n.notificationsContainer .notificationsContainer_action button svg {\n    width: 24px;\n    height: 24px;\n}\n", ""]);

// exports
